"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextLives = void 0;

var _react = _interopRequireDefault(require("react"));

var _DomestikaNextLiveCard = require("../DomestikaNextLiveCard");

var _BaseCarousel = require("./BaseCarousel");

var carouselConfig = {
  carouselWidth: ['100vw'],
  navControlsWidth: {
    XS: 0,
    SM: 0,
    MD: 908,
    LG: 1160
  },
  navControlsMargin: {
    XS: 0,
    SM: 0,
    MD: -20,
    LG: -20
  },
  navControlsColor: 'light',
  itemsWrapperPaddingX: {
    XS: 0,
    SM: 0,
    MD: 0,
    LG: 0
  },
  itemsWrapperPaddingY: {
    XS: 0,
    SM: 0,
    MD: 0,
    LG: 0
  },
  itemsMargin: {
    XS: 8,
    SM: 20,
    MD: 20,
    LG: 20
  },
  edgeItemsMargin: {
    XS: 16,
    SM: 24,
    MD: 0,
    LG: 0
  },
  itemsWidth: {
    XS: 288,
    SM: 473,
    MD: 454,
    LG: 580
  }
};

var NextLives = function NextLives(_ref) {
  var items = _ref.items,
      loading = _ref.loading;

  var getItemTemplate = function getItemTemplate(props) {
    return _react.default.createElement(_DomestikaNextLiveCard.DomestikaNextLiveCard, props);
  };

  return _react.default.createElement(_BaseCarousel.BaseCarousel, {
    items: items,
    loading: loading,
    carouselConfig: carouselConfig,
    itemTemplate: getItemTemplate
  });
};

exports.NextLives = NextLives;
NextLives.defaultProps = {
  items: [],
  loading: true
};